import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { AlertTriangleIcon, ClockIcon, StarIcon, TrophyIcon } from 'lucide-react';
import { CHECKOUT_URL, PRICE_FULL, PRICE_SHORT, Section, trackCheckoutClick } from './Shared';
import { Blossom, DropperBottle } from './FloralDecor';
function LaunchUrgency() {
  const [timeLeft, setTimeLeft] = useState({
    h: 0,
    m: 55,
    s: 51
  });
  const spotsTaken = 78;
  useEffect(() => {
    const timer = window.setInterval(() => setTimeLeft(current => {
      const seconds = Math.max(0, current.h * 3600 + current.m * 60 + current.s - 1);
      return {
        h: Math.floor(seconds / 3600),
        m: Math.floor(seconds % 3600 / 60),
        s: seconds % 60
      };
    }), 1000);
    return () => window.clearInterval(timer);
  }, []);
  const format = (value: number) => value.toString().padStart(2, '0');
  const TimeBox = ({
    value,
    label
  }: {
    value: number;
    label: string;
  }) => <div className="flex flex-col items-center" data-id="element-151" data-mp="12qpzvpeipt4n">
      <div className="min-w-[58px] rounded-xl bg-brand-green px-3 py-2 font-mono text-2xl font-bold tabular-nums text-brand-goldLight ring-1 ring-brand-gold/40 md:min-w-[80px] md:px-5 md:py-3 md:text-4xl" data-id="element-152" data-mp="12pewvrswcpel">
        {format(value)}
      </div>
      <span className="mt-1.5 text-[10px] font-semibold uppercase tracking-wider text-brand-muted md:text-sm" data-id="element-153" data-mp="17q2n4b9ax27r">
        {label}
      </span>
    </div>;
  return <div className="mx-auto mb-12 max-w-4xl" data-id="element-154" data-mp="1mhbhexo5fbr8">
      <div className="paper-panel rounded-3xl border-2 border-brand-gold/40 p-6 md:p-8" data-id="element-155" data-mp="1hfcd9lkl4at8">
        <div className="mb-5 flex items-center justify-center gap-2" data-id="element-156" data-mp="1vgf2g76vm18d">
          <ClockIcon className="h-5 w-5 text-brand-goldDark" data-id="element-157" data-mp="1qh2cveomeg23" />
          <h3 className="font-serif text-base font-bold text-brand-green md:text-xl" data-id="element-158" data-mp="1qhvclvp5w5aq">
            ⏰ PRECIO DE LANZAMIENTO — CIERRA EN:
          </h3>
        </div>
        <div className="mb-5 flex items-center justify-center gap-2 md:gap-4" data-id="element-159" data-mp="3s98hikr4qd6s">
          <TimeBox value={timeLeft.h} label="Horas" data-id="element-160" data-mp="1w5k7rnagj6i7" />
          <span className="pb-5 text-3xl font-bold text-brand-gold" data-id="element-161" data-mp="1w751jaoy6lf0">:</span>
          <TimeBox value={timeLeft.m} label="Min" data-id="element-162" data-mp="215gevvegbe1z" />
          <span className="pb-5 text-3xl font-bold text-brand-gold" data-id="element-163" data-mp="263hug6co4v8p">:</span>
          <TimeBox value={timeLeft.s} label="Seg" data-id="element-164" data-mp="2626tsfeis3lt" />
        </div>
        <div className="mb-6 flex items-center justify-center gap-2 rounded-xl border border-brand-gold/50 bg-brand-goldLight/40 px-4 py-3" data-id="element-165" data-mp="2a64p0f0q4u9l">
          <AlertTriangleIcon className="h-5 w-5 shrink-0 text-brand-goldDark" data-id="element-166" data-mp="2f226wprmy8oh" />
          <p className="text-center text-sm font-semibold text-brand-text md:text-base" data-id="element-167" data-mp="2k1oherg2xatl">
            Después sube. <span className="text-brand-greenMid" data-id="element-168" data-mp="2ourfncvsx8g4">No vuelve.</span>
          </p>
        </div>
        <div className="rounded-2xl border border-brand-green/15 bg-white p-4 md:p-5" data-id="element-169" data-mp="2tsj9icg0b4my">
          <div className="mb-3 flex flex-col gap-1 sm:flex-row sm:items-center sm:justify-between" data-id="element-170" data-mp="2xvyzwr1hg8r7">
            <span className="flex items-center gap-2 text-sm font-semibold text-brand-text md:text-base" data-id="element-171" data-mp="32uimmtnwhokm">
              <span className="relative flex h-2.5 w-2.5" data-id="element-172" data-mp="r7ypf8kas0bl">
                <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-brand-amber opacity-75" data-id="element-173" data-mp="m6svj7ewi70h" />
                <span className="relative inline-flex h-2.5 w-2.5 rounded-full bg-brand-amber" data-id="element-174" data-mp="i6if10thfy7d" />
              </span>
              Cupos al precio de lanzamiento
            </span>
            <span className="text-xs font-bold uppercase tracking-wide text-brand-rose" data-id="element-175" data-mp="19x4zk770zjls">Quedan pocos</span>
          </div>
          <div className="mb-2 h-2.5 w-full overflow-hidden rounded-full bg-brand-green/10" data-id="element-176" data-mp="15wl212ijidz4">
            <div className="h-full rounded-full bg-brand-greenMid" style={{
            width: `${spotsTaken}%`
          }} data-id="element-177" data-mp="113a6hxj6hjmi" />
          </div>
          <p className="text-center text-xs text-brand-muted md:text-sm" data-id="element-178" data-mp="w58bce8h9tuo">
            <strong className="text-brand-greenMid" data-id="element-179" data-mp="1tlxk6rvuhwdk">{spotsTaken}%</strong> de los cupos al precio de lanzamiento ya
            tomados
          </p>
        </div>
      </div>
    </div>;
}
function Pricing() {
  return <Section id="comprar" glow className="my-12 rounded-3xl border border-brand-gold/45 bg-brand-parchment" data-id="element-180" data-mp="18d3idjroew2j">
      <div aria-hidden="true" className="pointer-events-none absolute inset-0 -z-10 overflow-hidden rounded-3xl" data-id="element-181" data-mp="1dbn2demplxs9">
        <Blossom className="absolute left-6 top-8 h-20 w-20 text-brand-roseMist" data-id="element-182" data-mp="zgb9lcs46hdz" />
        <DropperBottle className="absolute bottom-6 right-8 hidden h-32 w-16 text-brand-sage/25 md:block" data-id="element-183" data-mp="14f5pa5usbptv" />
      </div>

      <div className="relative mb-10 text-center" data-id="element-184" data-mp="1w47s4n743mru">
        <span className="animate-glow-pulse mb-4 inline-flex items-center gap-2 rounded-full bg-brand-green px-4 py-1.5 text-[11px] font-bold uppercase tracking-wider text-brand-goldLight md:text-sm" data-id="element-185" data-mp="1w2xs3sgp84ik">
          🌿 Oferta de lanzamiento
        </span>
        <h2 className="font-display text-3xl font-bold text-brand-green md:text-4xl" data-id="element-186" data-mp="2b1i21s43wklg">
          TU <span className="text-brand-goldDark" data-id="element-187" data-mp="2azndm3tmmacm">BOTIQUÍN BACH COMPLETO</span>
        </h2>
        <p className="mt-3 text-sm font-semibold text-brand-greenMid md:text-base" data-id="element-188" data-mp="2fub6eevnxqx0">
          Cierra pronto. Después sube. No vuelve.
        </p>
      </div>

      <div className="mx-auto max-w-2xl space-y-5" data-id="element-189" data-mp="2l4dncvv9uire">
        <div className="relative rounded-3xl" data-id="element-190" data-mp="2ywtsq3bnasvh">
          <span className="glow-frame" aria-hidden="true" data-id="element-191" data-mp="2yvs754x06nzi" />
          <div className="relative z-10 rounded-3xl bg-white p-6 shadow-lg md:p-8" data-id="element-192" data-mp="2ty0do6gpmtt7">
            <div className="mb-3 flex items-center gap-1.5 text-brand-goldDark" data-id="element-193" data-mp="2u033oqhv4mxx">
              <TrophyIcon className="h-4 w-4 fill-current" data-id="element-194" data-mp="268fqtchfrcen" />
              <StarIcon className="h-4 w-4 fill-current" data-id="element-195" data-mp="227m60rzaidpz" />
              <span className="text-[10px] font-bold uppercase tracking-wider md:text-sm" data-id="element-196" data-mp="2g6c2c5eac9da">
                El kit argentino más completo
              </span>
            </div>
            <div className="flex flex-wrap items-end justify-between gap-6" data-id="element-197" data-mp="2b5xt4k0y6tdo">
              <div className="max-w-md" data-id="element-198" data-mp="3rk7f57hpw61c">
                <h3 className="font-serif text-lg font-bold text-brand-green md:text-xl" data-id="element-199" data-mp="3rnbqqpxii421">
                  🏆 BOTIQUÍN BACH COMPLETO™
                </h3>
                <p className="mt-1 text-sm text-brand-muted" data-id="element-200" data-mp="3umbzhiqp4g9b">2 Tomos + 5 Bonus · Más de 150 páginas</p>
                <p className="mt-2 text-sm font-medium leading-relaxed text-brand-greenMid" data-id="element-201" data-mp="2hq7p9tfq4d5">
                  El sistema integral de protocolos, fórmulas, técnicas tópicas, protección del terapeuta y
                  monetización profesional.
                </p>
              </div>
              <div className="shrink-0 text-right" data-id="element-202" data-mp="3b05u7jv0dnab">
                <p className="text-xs uppercase tracking-wide text-brand-muted" data-id="element-203" data-mp="3ax9zs5iddgqm">Valor original</p>
                <p className="text-lg text-brand-muted line-through" data-id="element-204" data-mp="3fvv1k9d9s8h6">{PRICE_FULL}</p>
                <p className="mt-1 text-xs uppercase tracking-wide text-brand-muted" data-id="element-205" data-mp="3kv7lomcrb1g2">Precio de lanzamiento</p>
                <p className="font-serif text-4xl font-bold text-brand-greenMid md:text-5xl" data-id="element-206" data-mp="3pptzew6b963b">{PRICE_SHORT}</p>
                <p className="text-xs text-brand-muted" data-id="element-207" data-mp="2x7pzd6c9gvkh">Acceso inmediato de por vida</p>
              </div>
            </div>
          </div>
        </div>

        <motion.a href={CHECKOUT_URL} onClick={trackCheckoutClick} whileHover={{
        scale: 1.03
      }} whileTap={{
        scale: 0.98
      }} transition={{
        duration: 0.14,
        ease: [0.23, 1, 0.32, 1]
      }} className="cta-shimmer relative flex w-full justify-center overflow-hidden rounded-full bg-brand-green px-6 py-5 text-center text-base font-bold text-brand-goldLight shadow-[0_12px_28px_rgba(14,42,30,.26)] ring-1 ring-brand-gold/50 md:text-xl" data-id="element-208" data-mp="2pnotm02c2v43">
          <span className="relative z-10" data-id="element-209" data-mp="21xujvrdb9mo2">→ QUIERO MI BOTIQUÍN BACH {PRICE_SHORT}</span>
        </motion.a>

        <div className="grid gap-3 rounded-2xl bg-brand-sageMist/70 p-4 text-center sm:grid-cols-4" data-id="element-210" data-mp="1x01bcrojcgkm">
          {['🛡️ Garantía 7 días', '📥 Descarga inmediata', '🔒 Pago seguro', '💳 Mercado Pago'].map(item => <span key={item} className="text-xs font-bold text-brand-greenMid" data-id="element-211" data-mp="1n3g748kcb9hu">
              {item}
            </span>)}
        </div>
      </div>
    </Section>;
}
export function LaunchOffer() {
  return <div className="mx-auto w-full max-w-7xl px-4 sm:px-6 lg:px-8" data-id="element-212" data-mp="3bvj5aretz3jj">
      <LaunchUrgency data-id="element-213" data-mp="3burl0cqoos8k" />
      <Pricing data-id="element-214" data-mp="3bt6q2m0gj7a6" />
    </div>;
}